import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BodyService } from '../../shared/_utils/body.service';
import { JsonApiService } from '../../core/api/json-api.service';
import { catchError, map, tap} from 'rxjs/operators';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { environment } from './../../../environments/environment';
import { SpinnerService } from 'app/core/services/spinner.service'; 
import { ExecutingUnit } from 'app/core/entities/executingUnit';
import { ResponsePageable } from 'app/shared/_utils/services/responsePageable';
import { UserSystem } from 'app/_entity/userSystem/userSystem';

@Injectable()
export class AuthenticationService {
    constructor(private httpClient: HttpClient,
        private bodyService: BodyService,
        private jsonApiService: JsonApiService,
        private spinnerService: SpinnerService,
        protected router: Router) { }

    login(username: string, password: string) {
        // debugger;
        this.logoin();
        const rutaServidor = localStorage.getItem('rutaServidor');
        const tokenUrl = rutaServidor + '/api/authentication';
        // const tokenUrl = rutaServidor + "/api/auth"; 

        let headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/json');
        return this.httpClient.post(tokenUrl, JSON.stringify({ username: username, password: password }), { headers: headers })
            .pipe(
                map((response: any) => {
                    // debugger;
                    ///console.log(response);
                    if(response.userSystem.employeeId == null  ){//ingresa
                        const currentToken = response.token;
                                            sessionStorage.setItem('tokenIni', currentToken);
                                            const user = response;
                                            if (user && user.token) {
                                                sessionStorage.setItem('currentUser', JSON.stringify(user));

                                            }
                        return true;
                    }
                    else if(response.userSystem.status ==false ){ // no ingresa
                        return false;
                    }
                    else if (response.userSystem.status || response.userSystem.employeeId != null ){ // se evalua su ingreso
                        const currentToken = response.token;
                                            sessionStorage.setItem('tokenIni', currentToken);
                                            const user = response;
                                            if (user && user.token) {
                                                sessionStorage.setItem('currentUser', JSON.stringify(user));

                                            }
                        return response.userSystem.employeeId;
                    }
                    //console.log("Se termino de logear");
                    // debugger;
                }),
                catchError((err, caught) => {
                    // debugger;
                    this.bodyService.handleError(err);
                    return Observable.empty();
                })); 
    }



    logoin() { 
        //let url = environment.apiUrl + '8081/personalModule';
        let url = environment.apiUrl + '/adminAuthModule';
       // let url = environment.apiUrl + '8080/adminAuthModule';
        //console.log("url :" + url);
        localStorage.setItem('rutaServidor',url);
        sessionStorage.setItem('sm-fixed-header', 'true');
        sessionStorage.setItem('defaultLocale', navigator.language.substr(0,2));
        sessionStorage.setItem('expiracion', 'N');
        //this.obtenerI18n(); 
    }

    logout() {
        // remove user from local storage to log user out
        // debugger;
        this.bodyService.logout();

    }

    private obtenerI18n() {
        const i18n = sessionStorage.getItem('defaultLocale');
        if (i18n === 'es') {
            this.jsonApiService.fetch('/langs/es.json')
                .subscribe(data => {
                    const datai18n = JSON.stringify(data);
                   //localStorage.setItem('datai18n', datai18n);
                   //console.log("Redirigiendo a home...");
                    // this.router.navigate(['home']);
                    this.router.navigate(['home']);
                })
                ;
        } else {
            this.jsonApiService.fetch('/langs/us.json')
                .subscribe(data => {
                    const datai18n = JSON.stringify(data);
                   // localStorage.setItem('datai18n', datai18n);
                    this.router.navigate(['home']);
                });
        }
    }
 
    getMenuSideBar(user_id : number, module_id :number):Observable<any>{   
        const rutaServidor = localStorage.getItem('rutaServidor');
        //console.log("rutaServidor :" + rutaServidor);
        const url =  rutaServidor + '/api/user/menuSideBar'; 
        //console.log("url :" + url);
        return this.httpClient.get(url + "?user_id=" + user_id +"&module_id="+ module_id);
    }

    getModules(user_id : number):Observable<any>{   
        const rutaServidor = localStorage.getItem('rutaServidor');
        //console.log("rutaServidor :" + rutaServidor);
        const url =  rutaServidor + '/api/user/modules'; 
        //console.log("url :" + url);
        this.spinnerService.showAll();
        return this.httpClient.get(url + "?user_id=" + user_id).pipe(
            tap(response => {
              this.spinnerService.hideAll();
            }),
          catchError((err, caught) => {
              // debugger;
              this.spinnerService.hideAll();
              this.bodyService.handleError(err);
              return Observable.empty();
          })); 
    }
 
    searchEmployeeFile(user_id : number):Observable<any>{ 
        const rutaServidor = localStorage.getItem('rutaServidor');
        let url = rutaServidor + '/api/employeeFile/search';
        let p ="?q=employee.id_eq_"+ user_id 
        return this.httpClient.get(url + p);
    }

    forgetPassword(email : string , docNumber : string){ 
        const rutaServidor = environment.apiUrl + '/adminAuthModule';
        //const rutaServidor = environment.apiUrl + '8080/adminAuthModule';
        let url = rutaServidor + '/api/forgotPassword/';
        let p ="?email="+ email +"&docNumber="+docNumber;
        //let p ="user_id="+10;
        this.spinnerService.showAll();
        return this.httpClient.get(url + p).pipe(
            tap(response => {
              this.spinnerService.hideAll();
            }),
          /*catchError((err, caught) => {
              // debugger;
              this.spinnerService.hideAll();
              //this.bodyService.handleError(err);
              //return Observable.empty();
          })*/
          ); 
    }

    /*
    loginForgotPassword(username: string, password: string) {
        // debugger;
        let url = environment.apiUrl + '/adminAuthModule';
        //let url = environment.apiUrl + '8080/adminAuthModule';
        //console.log("url :" + url);
        localStorage.setItem('rutaServidor',url);
        sessionStorage.setItem('sm-fixed-header', 'true');
        sessionStorage.setItem('defaultLocale', 'es');
        sessionStorage.setItem('expiracion', 'N'); 

        let rutaServidor = localStorage.getItem('rutaServidor');
        let tokenUrl = rutaServidor + '/api/authentication';
        // const tokenUrl = rutaServidor + "/api/auth"; 

        let headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/json');
        return this.httpClient.post(tokenUrl, JSON.stringify({ username: username, password: password }), { headers: headers })
            .pipe(
                map((response: any) => {
                    // debugger;
                    const currentToken = response.token;
                    sessionStorage.setItem('tokenIni', currentToken);
                    const user = response;
                    if (user && user.token) {
                        sessionStorage.setItem('currentUser', JSON.stringify(user));

                    }
                    //console.log("Se termino de logear");
                    // debugger;
                }),
                catchError((err, caught) => {
                    // debugger;
                    this.bodyService.handleError(err);
                    return Observable.empty();
                })); 
    }  
    */


    changePassword(userId : number ,oldPassword :string , newPassword : string){ 
        let rutaServidor =  environment.apiUrl + '/adminAuthModule';
        //let rutaServidor =  environment.apiUrl + '8080/adminAuthModule';
        let url = rutaServidor + '/api/user/changePassword/';
        let p ="?userId="+ userId +"&oldPassword="+oldPassword +"&newPassword="+newPassword;
        //let p ="user_id="+10;
        this.spinnerService.showAll();
        return this.httpClient.get(url + p).pipe(
            tap(response => {
              this.spinnerService.hideAll();
            }),
          catchError((err, caught) => {
              // debugger;
              this.spinnerService.hideAll();
              this.bodyService.handleError(err);
              return Observable.empty();
          })); 
    }

    loginModules(username: string, password: string,rutaServidor:string) {
        // debugger;
        //this.logoin();
       // const rutaServidor = localStorage.getItem('rutaServidor');
        const tokenUrl = rutaServidor + '/api/authentication';
        // const tokenUrl = rutaServidor + "/api/auth"; 
        this.spinnerService.showAll();
        let headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/json');
        return this.httpClient.post(tokenUrl, JSON.stringify({ username: username, password: password }), { headers: headers })
            .pipe(
                map((response: any) => {
                    // debugger;
                    const currentToken = response.token;
                    this.spinnerService.showAll();
                    sessionStorage.setItem('token', currentToken); 
                    const user = response;
                    if (user && user.token) {
                        //sessionStorage.setItem('currentUser', JSON.stringify(user)); 
                    }
                    
                }),
                 catchError((err, caught) => {
                    // debugger;
                    this.spinnerService.showAll();
                    this.bodyService.handleError(err);
                    return Observable.empty();
                }) 
                ); 
    }


     obtenerI18n2() :Observable<any> {
        const i18n = sessionStorage.getItem('defaultLocale');
        //console.log("defaultLocale en obtenerI18n2 ... ", i18n);
        if (i18n === 'es') {
            this.jsonApiService.fetch('/langs/es.json')
                .subscribe(data => {
                    const datai18n = JSON.stringify(data);
                     localStorage.setItem('datai18n', datai18n);
                   //console.log("Redirigiendo a home...");
                    // this.router.navigate(['home']); 
                })
                ;
        } else {
            this.jsonApiService.fetch('/langs/us.json')
                .subscribe(data => {
                    const datai18n = JSON.stringify(data);
                    localStorage.setItem('datai18n', datai18n); 
                });
        }
        return new Observable();
    }

    downloadUserManual(eu: number) { 
        let rutaServidor =  environment.apiUrl + '/adminAuthModule';
        //let rutaServidor =  environment.apiUrl + '8080/adminAuthModule';
          this.spinnerService.showAll();
        return this.httpClient.get( rutaServidor + '/api/user/downloadUserManual/'+eu,
          {            responseType: 'blob',
          })
          .pipe(
            tap(response => {
             //console.log(response);
              this.spinnerService.hideAll();
              return response;
            })
          );
      }

    getUserDateFormat(user_id : number):Observable<any>{ 
        const rutaServidor = localStorage.getItem('rutaServidor');
        let url = rutaServidor + '/api/user/dateFormat';
        let p ="/"+ user_id 
        return this.httpClient.get(url + p);
    }

    getExecutingUnitById(id: string | number): Observable<ExecutingUnit> {
        // debugger;
        const rutaServidor = localStorage.getItem('rutaServidor');
        const url = rutaServidor + '/api/executingUnit/' + id;
        this.spinnerService.showAll();
        return this.httpClient.get<any>(url)
            .pipe(
                tap((response: ResponsePageable<ExecutingUnit>) => {
                   //console.log(response);
                    if (response.numberOfElements > 0) {
                        //this.convertToDate(response.content[0]);
                    }
                    this.spinnerService.hideAll();
                }),
                
                map((response: ResponsePageable<ExecutingUnit>) => response.content[0])
            );
    }


    validarContratoActivo(employee_id : number):Observable<any>{ 
        const rutaServidor = localStorage.getItem('rutaServidor');
        let url = rutaServidor + '/api/employeeContract/validateContract';
        let p ="?employee="+ employee_id
        return this.httpClient.get(url + p);
    }
}


// WEBPACK FOOTER //
// ./src/app/+auth/+login/authentication.service.ts